import React, { FC, PropsWithChildren } from 'react'
import { Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s, AllSystemProps } from '@moonpig/launchpad-system'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'

const StyledSoldOutOverlay = styled(Box)`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  z-index: 1;
  opacity: 0.75;
  ${s({
    typography: { xs: 'typeMobileDisplay01', md: 'typeDesktopDisplay02' },
    bgcolor: 'colorBlack00',
  })}
`

export const SoldOutWrapper: FC<PropsWithChildren<AllSystemProps>> = ({
  children,
  ...rest
}) => {
  const localiseText = useCoreLocaleText()
  return (
    <Box position="relative" {...rest}>
      <StyledSoldOutOverlay>
        {localiseText('common.sold_out')}
      </StyledSoldOutOverlay>
      {children}
    </Box>
  )
}
